import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

import '@splidejs/splide/css';

export default class Partenaires {
    namespace: string = 'partenaires';

    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            const partenairesContainerAll = document.querySelectorAll<HTMLDivElement>('.custom-container-partenaires');
            const uagbBlockAll = document.querySelectorAll<HTMLElement>('.entry-content > section');

            if (partenairesContainerAll.length) {
                partenairesContainerAll.forEach($partenaireSection => {
                    this.init($partenaireSection);
                });
            }

            if (uagbBlockAll.length) {
                uagbBlockAll.forEach($uagbBlock => {
                    this.addClassToParents($uagbBlock);
                })
            }
        }, false);
    }

    addClassToParents($uagbBlock: HTMLElement) {
        console.log($uagbBlock);
        if ($uagbBlock.querySelectorAll('.custom-container-partenaires').length) {
            $uagbBlock.classList.add('block-has-partenaires');
        }
    }

    init($partenaireSection: HTMLDivElement) {
        const partenaireId = $partenaireSection.getAttribute('id');
        const nbPartenaires = $partenaireSection.querySelectorAll<HTMLElement>('.partenaire-item').length;
        const clones = nbPartenaires > 6 ? 4 : 10;


        new Splide( '#' + partenaireId + ' .splide', {
            type   : 'loop',
            drag   : 'free',
            focus  : 'center',
            clones : clones,
            perPage: 6,
            autoWidth: true,
            arrows: false,
            autoScroll: {
                speed: 1,
            },
        } ).mount({ AutoScroll } );
    }
}
